import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../context/LangContext';

export default function MobileDrawer({ isOpen, onClose }) {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const go = (path) => { onClose(); navigate(path); };
  const at = (path) => {
    if (path === '/') return location.pathname === '/' ? ' active' : '';
    return location.pathname === path || location.pathname.startsWith(path + '/') ? ' active' : '';
  };

  return (
    <>
      <div className={`mob-overlay${isOpen?' open':''}`} style={{display:isOpen?'block':'none'}} onClick={onClose}/>
      <div className={`mob-drawer${isOpen?' open':''}`}>
        <div className="mob-drawer-head">
          <span className="ml">{t('mob.menu')}</span>
          <button className="mc" onClick={onClose}>✕</button>
        </div>
        <div className="mob-drawer-search">
          <input type="text" placeholder={t('mob.search')}
            onKeyDown={e=>{if(e.key==='Enter')go(`/fatwas?q=${encodeURIComponent(e.target.value)}`);}}/>
        </div>
        <div className="mob-nav-section">
          <div className="mob-nav-title">{t('mob.nav')}</div>
          <div className={`mob-nav-a${at('/')}`} onClick={()=>go('/')}>{t('mob.home2')}</div>
          <div className={`mob-nav-a${at('/fatwas')}`} onClick={()=>go('/fatwas')}>{t('mob.fatwa2')}</div>

          <div className={`mob-nav-a${at('/articles')}`} onClick={()=>go('/articles')}>{t('mob.articles2')}</div>
          <div className={`mob-nav-a${at('/lectures')}`} onClick={()=>go('/lectures')}>{t('mob.lectures2')}</div>
          <div className={`mob-nav-a${at('/research')}`} onClick={()=>go('/research')}>{t('mob.research2')}</div>
          <div className={`mob-nav-a${at('/scholars')}`} onClick={()=>go('/scholars')}>{t('mob.scholars2')}</div>
        </div>
        <div className="mob-drawer-cta">
          <div className="mob-cta-btn primary" onClick={()=>go('/donate')}>{t('mob.cta.donate')}</div>
          <div className="mob-cta-btn ghost"   onClick={()=>go('/contact')}>{t('mob.cta.ask')}</div>
        </div>
      </div>
    </>
  );
}